module.exports = __webpack_public_path__ + "img/discord.105dc8aa.svg";